import { render } from "./Q6DetailleeOptionA.vue?vue&type=template&id=0fffcc54"
import script from "./Q6DetailleeOptionA.vue?vue&type=script&lang=js"
export * from "./Q6DetailleeOptionA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__